import { Module } from "src/state/Module"
import * as Types from "src/state/gql/_types"

export const MessageModule = new Module<Types.MessageFragment, Types.GetMessagesQueryVariables, Types.Messages_Insert_Input>({
    sortKey: 'created_at',
})